/**
 * Firebase Configuration
 *
 * Provides Firebase app initialization configuration.
 * These values are required for Firebase services (FCM, Auth, etc.)
 */

import type { FirebaseOptions } from 'firebase/app';

/**
 * Firebase configuration object
 * Contains all required Firebase project credentials
 */
const firebaseConfig: FirebaseOptions = {
  apiKey: "AIzaSyA0sDe8RM4XMlzW6XrKSTp9kNN2mF5DwRY",
  authDomain: "roomsensorgcp01.firebaseapp.com",
  projectId: "roomsensorgcp01",
  storageBucket: "roomsensorgcp01.appspot.com",
  messagingSenderId: "892070848913",
  appId: "1:892070848913:web:8f76b82fb9f1db08e59230",
  measurementId: "G-2J4FCJP3Y6"
};

export default firebaseConfig;
